/*
 * Author: Harper Yan
 * File Created: Thursday, 25-02-20 10:44 am
 * Last Modified: Tuesday, 25-04-22 03:40 pm, by Roger
 */
import Lottie from 'lottie-react';
import animationData from './landing_black.json';
interface DeCardVisaProps {
  width?: number | string;
  height?: number | string;
}
const DeCardVisa = ({
  width,
  height
}: DeCardVisaProps) => <Lottie animationData={animationData} autoplay height={height} loop width={width} data-sentry-element="Lottie" data-sentry-component="DeCardVisa" data-sentry-source-file="index.tsx" />;
export default DeCardVisa;